<template>
  <section class="ranu-statistics">
    <Breadcrumbs
      :breadcrumbs="[
        { title: $t('menu.ranu'), disabled: true },
        { title: $t('ranu.statistics.title'), disabled: true }
      ]">
    </Breadcrumbs>

    <div class="evollu-form row">

      <div class="col-12 col-sm-4 col-md-4">
        <label class="form-label">
          {{ $t('homelab.labels.entities') }}
        </label>
        <multiselect
          id="entities-or-clusters-multiselect"
          v-model="filters.entities"
          :options="entityOptions"
          track-by="uid"
          :customLabel="formatedEntityLabel"
          :placeholder="$t('homelab.labels.accumulated_values')"
          :allow-empty="true"
          :multiple="true"
        >
          <template slot="clear">
            <span class="multiselect__clear" v-if="filters.entities.length > 0"
                  @mousedown.prevent.stop="filters.entities = []"></span>
          </template>
        </multiselect>
      </div>

      <div class="col-12 col-sm-4 col-md-4">
        <label class="form-label">{{ $t('ranu.statistics.birthdate') }}</label>
        <range-date-picker
          id="statistics-date-range"
          v-model="filters.dateRange"
          placeholder="---"
          :clearable="false"
        >
        </range-date-picker>
      </div>

    </div>

    <div class="py-3">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4">

          <horizontal-donut-chart-widget
            :title="$t('ranu.statistics.records')"
            :hidePercentage="true"
            :data="birthsChartData"
          >
          </horizontal-donut-chart-widget>
        </div>

        <div class="col-12 col-sm-4 col-md-4">
          <SimpleKPIWidget
            :title="$t('ranu.statistics.tested_percentage')"
            :hidePercentage="true"
            :value="percentageTestedPerBirth"
            :divider="10"
            :label="$t('ranu.statistics.tested_per_records')"
          >
            <div slot="afterTitle">
              <span class="is-bold">{{`Total: ${totalTested}`}}</span>
            </div>
            <div slot="afterValue">
              %
            </div>
          </SimpleKPIWidget>
        </div>

        <div class="col-12 col-sm-4 col-md-4">
          <horizontal-donut-chart-widget
            :title="$t('ranu.statistics.risk_factor')"
            :hidePercentage="true"
            :data="riskFactorsChartData"
          >
          </horizontal-donut-chart-widget>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-4 col-md-4">
          <horizontal-donut-chart-widget
            :title="'O.E.A.1'"
            :hidePercentage="true"
            :data="OEA1ChartData"
          >
          </horizontal-donut-chart-widget>
        </div>

        <div class="col-12 col-sm-4 col-md-4">
          <horizontal-donut-chart-widget
            :title="'O.E.A.2'"
            :hidePercentage="true"
            :data="OEA2ChartData"
          >
          </horizontal-donut-chart-widget>
        </div>

        <div class="col-12 col-sm-4 col-md-4">
          <horizontal-donut-chart-widget
            :title="'P.E.A.A.'"
            :hidePercentage="true"
            :data="PEAAChartData"
          >
          </horizontal-donut-chart-widget>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-4 col-md-4">
          <horizontal-donut-chart-widget
            :title="'Encaminhado para Consulta'"
            :hidePercentage="true"
            :data="ConsultaChartData"
          >
          </horizontal-donut-chart-widget>
        </div>

        <div class="col-12 col-sm-4 col-md-4">
          <horizontal-donut-chart-widget
            :title="'P.E.A.T.C.'"
            :hidePercentage="true"
            :data="PEATCChartData"
          >
          </horizontal-donut-chart-widget>
        </div>

        <div class="col-12 col-sm-4 col-md-4">
          <horizontal-donut-chart-widget
            :title="'Totais'"
            :hidePercentage="true"
            :hideTotal="true"
            :data="TotalsChartData"
          >
          </horizontal-donut-chart-widget>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import DashboardInfoWidgets from '../../dashboard/DashboardInfoWidgets'
import HorizontalDonutChartWidget from '@/components/common/statistics/HorizontalDonutChartWidget'
import SimpleKPIWidget from '@/components/common/statistics/SimpleKPIWidget'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import { FILTERS_RANU_STATISTICS } from '@/local-storage/LocalStorageKeys'
import Breadcrumbs from '@/components/common/Breadcrumbs'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import { mapGetters } from 'vuex'
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin'

export default {
  props: {
    component: {
      type: Object,
      required: true
    }
  },
  components: {
    RangeDatePicker,
    Breadcrumbs,
    DashboardInfoWidgets,
    Multiselect,
    HorizontalDonutChartWidget,
    SimpleKPIWidget
  },
  mixins: [
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  data () {
    return {
      filters: {
        dateRange: {
          start: this.moment().subtract(1, 'months').format('YYYY-MM-DD'),
          end: this.moment().format('YYYY-MM-DD')
        },
        entities: []
      },
      selectedEntityIds: [],
      selectedEntityUids: [],
      originalData: [],
      hasLoadedLocalStorage: false
    }
  },
  created () {
    this.loadLocalStorage()
      .then(() => this.loadData())
  },
  methods: {
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(FILTERS_RANU_STATISTICS)
        if (state) {
          if (Array.isArray(state.selectedEntityUids) && state.selectedEntityUids) {
            this.filters.entities = this.reloadSelectedClustersAndEntities(this.entityOptions, state.selectedEntityUids)
          }

          if (state.dateRange && state.dateRange.start && state.dateRange.start !== '' && state.dateRange.end && state.dateRange.end !== '') {
            this.filters.dateRange.start = state.dateRange.start
            this.filters.dateRange.end = state.dateRange.end
          }
        }

        this.hasLoadedLocalStorage = true

        resolve()
      })
    },
    saveLocalStorage: function () {
      LocalStorageHelper.set(FILTERS_RANU_STATISTICS, {
        dateRange: this.filters.dateRange,
        selectedEntityUids: this.selectedEntityUids
      })
    },
    loadData () {
      return new Promise((resolve, reject) => {
        this.$http({
          url: `${this.component.service.url}/v2/statistics`,
          params: {
            from: this.filters.dateRange.start,
            until: this.filters.dateRange.end
          }
        }).then((response) => {
          this.originalData = response.data.data
          resolve()
        })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  computed: {
    ...mapGetters([
      'clusters',
    ]),
    ranuService: function () {
      return this.component.service
    },
    readableEntities: function () {
      let appointmentPermissions = this.ranuService.user_permissions.filter(permission => permission.access_type >= 1 && permission.info_type === 100)
      if (appointmentPermissions.length > 0) {
        if (appointmentPermissions.some(permission => permission.entity_id === null)) {
          return [...this.ranuService.entities]
        } else {
          return appointmentPermissions.map(permission => this.ranuService.entities.find(entity => permission.entity_id === entity.id)).filter(v => v)
        }
      }
    },
    entityOptions: function () {
      return this.createClustersAndEntitiesList(this.clusters, this.readableEntities)
    },
    filteredData: function () {
      return this.selectedEntityIds.length ? this.originalData.filter(element => this.selectedEntityIds.includes(element.entity_id)) : this.originalData
    },
    birthsChartData: function () {
      if (this.filteredData.length) {
        let births = this.filteredData.reduce((accumulator, value) => accumulator + value.births, 0)
        let birthsExternal = this.filteredData.reduce((accumulator, value) => accumulator + value.births_external, 0)
        let deaths = this.filteredData.reduce((accumulator, value) => accumulator + value.deaths, 0)
        let deathsExternal = this.filteredData.reduce((accumulator, value) => accumulator + value.deaths_external, 0)

        return {
          labels: [
            this.$t('ranu.statistics.births'),
            this.$t('ranu.statistics.births_external'),
            this.$t('ranu.statistics.deaths'),
            this.$t('ranu.statistics.deaths_external')
          ],
          datasets: [{
            data: [births, birthsExternal, deaths, deathsExternal],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c'
            ]
          }]
        }
      }
    },
    percentageTestedPerBirth: function () {
      if (this.filteredData.length) {
        let selectedTestedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.tested, 0)
        let selectedEntitiesTotal = this.filteredData.reduce((accumulator, value) => accumulator + value.total, 0)

        if (isNaN(selectedTestedCount / selectedEntitiesTotal)) {
          return 0
        }
        return (selectedTestedCount / selectedEntitiesTotal) * 100
      } else {
        return 0
      }
    },
    totalTested: function () {
      if (this.filteredData.length) {
        return this.filteredData.reduce((accumulator, value) => accumulator + value.tested, 0)
      } else {
        return 0
      }
    },
    riskFactorsChartData: function () {
      if (this.filteredData.length) {
        return {
          labels: [
            'SF',
            'IC',
            'AC',
            'BP',
            'MO',
            'MB',
            'AP',
            'VM',
            'SA',
            'HI-HE',
            'COVID-19'
          ],
          datasets: [{
            data: [
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.SF, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.IC, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.AC, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.BP, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.MO, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.MB, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.AP, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.VM, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.SA, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.HIHE, 0),
              this.filteredData.reduce((accumulator, value) => accumulator + value.risk_factors.COVID, 0)
            ],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#ffc000',
              '#2ced89',
              '#17a6aa'
            ]
          }]
        }
      }
    },
    OEA1ChartData: function () {
      if (this.filteredData.length) {
        let passedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA1.pass, 0)
        let referCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA1.refer, 0)
        let missedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA1.missed, 0)
        let transferredCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA1.transferred, 0)
        let diedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA1.died, 0)

        return {
          labels: [
            this.$t('ranu.statistics.passed'),
            this.$t('ranu.statistics.refer'),
            this.$t('ranu.statistics.missed'),
            this.$t('ranu.statistics.transferred'),
            this.$t('ranu.statistics.died')
          ],
          datasets: [{
            data: [passedCount, referCount, missedCount, transferredCount, diedCount],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#bc5448'
            ]
          }]
        }
      }
    },
    OEA2ChartData: function () {
      if (this.filteredData.length) {
        let passedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA2.pass, 0)
        let referCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA2.refer, 0)
        let missedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA2.missed, 0)
        let transferredCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA2.transferred, 0)
        let diedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.OEA2.died, 0)

        return {
          labels: [
            this.$t('ranu.statistics.passed'),
            this.$t('ranu.statistics.refer'),
            this.$t('ranu.statistics.missed'),
            this.$t('ranu.statistics.transferred'),
            this.$t('ranu.statistics.died')
          ],
          datasets: [{
            data: [passedCount, referCount, missedCount, transferredCount, diedCount],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#bc5448'
            ]
          }]
        }
      }
    },
    PEAAChartData: function () {
      if (this.filteredData.length) {
        let passedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEAA.pass, 0)
        let referCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEAA.refer, 0)
        let missedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEAA.missed, 0)
        let transferredCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEAA.transferred, 0)
        let diedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEAA.died, 0)

        return {
          labels: [
            this.$t('ranu.statistics.passed'),
            this.$t('ranu.statistics.refer'),
            this.$t('ranu.statistics.missed'),
            this.$t('ranu.statistics.transferred'),
            this.$t('ranu.statistics.died')
          ],
          datasets: [{
            data: [passedCount, referCount, missedCount, transferredCount, diedCount],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#bc5448'
            ]
          }]
        }
      }
    },
    ConsultaChartData: function () {
      if (this.filteredData.length) {
        let passedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.Consulta.pass, 0)
        // let referCount = this.filteredData.reduce((accumulator, value) => accumulator + value.Consulta.refer, 0)
        let missedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.Consulta.missed, 0)
        let transferredCount = this.filteredData.reduce((accumulator, value) => accumulator + value.Consulta.transferred, 0)
        let diedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.Consulta.died, 0)

        return {
          labels: [
            this.$t('ranu.statistics.made'),
            // this.$t('ranu.statistics.refer'),
            this.$t('ranu.statistics.missed'),
            this.$t('ranu.statistics.transferred'),
            this.$t('ranu.statistics.died')
          ],
          datasets: [{
            data: [passedCount, missedCount, transferredCount, diedCount],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#bc5448'
            ]
          }]
        }
      }
    },
    PEATCChartData: function () {
      if (this.filteredData.length) {
        let passedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEATC.pass, 0)
        let referCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEATC.refer, 0)
        let missedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEATC.missed, 0)
        let transferredCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEATC.transferred, 0)
        let diedCount = this.filteredData.reduce((accumulator, value) => accumulator + value.PEATC.died, 0)

        return {
          customTotal: passedCount + referCount,
          labels: [
            this.$t('ranu.statistics.normal'),
            this.$t('ranu.statistics.changed'),
            this.$t('ranu.statistics.missed'),
            this.$t('ranu.statistics.transferred'),
            this.$t('ranu.statistics.died')
          ],
          datasets: [{
            data: [passedCount, referCount, missedCount, transferredCount, diedCount],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#bc5448'
            ]
          }]
        }
      }
    },
    TotalsChartData: function () {
      if (this.filteredData.length) {
        let birthsCount = this.filteredData.reduce((accumulator, value) => accumulator + (value.births + value.births_external), 0)
        let passedCount = this.filteredData.reduce((accumulator, value) => accumulator + (value.OEA1.pass + value.OEA2.pass + value.PEAA.pass + value.PEATC.pass + value.Consulta.pass), 0)

        let referCount = this.filteredData.reduce((accumulator, value) => accumulator + (value.OEA1.refer + value.OEA2.refer + value.PEAA.refer + value.PEATC.refer + value.Consulta.refer), 0)
        let missedCount = this.filteredData.reduce((accumulator, value) => accumulator + (value.OEA1.missed + value.OEA2.missed + value.PEAA.missed + value.PEATC.missed + value.Consulta.missed), 0)
        let transferredCount = this.filteredData.reduce((accumulator, value) => accumulator + (value.OEA1.transferred + value.OEA2.transferred + value.PEAA.transferred + value.PEATC.transferred + value.Consulta.transferred), 0)
        let diedCount = this.filteredData.reduce((accumulator, value) => accumulator + (value.OEA1.died + value.OEA2.died + value.PEAA.died + value.PEATC.died + value.Consulta.died), 0)

        return {
          labels: [
            this.$t('ranu.statistics.births'),
            this.$t('ranu.statistics.passed'),
            this.$t('ranu.statistics.refer'),
            this.$t('ranu.statistics.missed'),
            this.$t('ranu.statistics.transferred'),
            this.$t('ranu.statistics.died')
          ],
          datasets: [{
            data: [birthsCount, passedCount, referCount, missedCount, transferredCount, diedCount],
            backgroundColor: [
              '#ffc000',
              '#2ced89',
              '#17a6aa',
              '#69120c',
              '#bc5448',
              '#17a6aa'
            ]
          }]
        }
      }
    }
  },
  watch: {
    'filters.entities': function (options) {
      const selectedOptions = this.getSelectedOptionsIdsAndUids(options)
      this.selectedEntityUids = selectedOptions.uids
      this.selectedEntityIds = selectedOptions.ids
      this.saveLocalStorage()
    },
    'filters.dateRange': function (value) {
      if (this.hasLoadedLocalStorage) {
        this.loadData()
      }
      this.saveLocalStorage()
    }

  },

}
</script>
